riot.tag2('page-index-carousel', '<div class="my-carousel"><div><a data-title="{photo[1].replace(/-/g, &#39; &#39;)}" each="{photo,i in topPhotos}" href="{&#39;#&#39;+photo[0]+&#39;!&#39;}" id="{i}"><img data-id="{i}" onclick="{start}"></a></div></div>', '.my-carousel{height:20vw;min-height:200px;max-height:300px;x-overflow:hidden;white-space:nowrap}.my-carousel div{position:relative}.my-carousel div>a{width:auto !important;position:absolute;transition:left .3s ease}.my-carousel div>a:hover:after{content:attr(data-title);display:block;color:#fff;position:absolute;left:20px;bottom:10px;z-index:100;text-shadow:1px 1px 3px #000}.my-carousel div>a>img{height:20vw;min-height:200px;max-height:300px;width:auto !important;position:relative;z-index:10;transition:.3s filter linear}', '', function(opts) {
(function() {
  var loadImages;

  this.topPhotos = [["one", "sendai-international-center"], ["two", "sendai-city"], ["three", "osaki-hachiman-shrine"], ["four", "izumi-ga-dake-mt"], ["five", "date-masamune-statue"], ["six", "akiu-hot-spring"]];

  this.images = [];

  this.centerImage = 0;

  loadImages = (function(_this) {
    return function() {
      var d, i, img, k, len, loadedImageCount, photo, ref;
      loadedImageCount = 0;
      d = new $.Deferred;
      ref = _this.topPhotos;
      for (i = k = 0, len = ref.length; k < len; i = ++k) {
        photo = ref[i];
        img = $(_this.root).find(".my-carousel img[data-id=" + i + "]");
        img.on("load", function() {
          loadedImageCount += 1;
          if (loadedImageCount === _this.topPhotos.length) {
            return d.resolve();
          }
        });
        img[0].src = 'images/top-photos/' + photo[1] + '.jpg';
      }
      return d.promise();
    };
  })(this);

  this.start = (function(_this) {
    return function(n) {
      var containerLeft, containerWidth, i, image, j, k, l, len, m, ref, ref1, ref2, ref3, ref4, totalWidth, x;
      _this.stop();
      if (typeof n === 'object') {
        _this.centerImage = +$(n.target).attr('data-id');
        console.log([_this.centerImage]);
      } else if (n) {
        _this.centerImage = n;
      } else {
        _this.centerImage = (_this.centerImage + 1) % _this.images.length;
      }
      totalWidth = 0;
      ref = _this.images;
      for (k = 0, len = ref.length; k < len; k++) {
        image = ref[k];
        totalWidth += image.width();
      }
      $(_this.root.firstChild.firstChild).width(totalWidth);
      containerWidth = $(_this.root.firstChild).width();
      containerLeft = $(_this.root.firstChild).offset()['left'];
      x = containerLeft + (containerWidth - _this.images[_this.centerImage].width()) / 2;
      for (i = l = ref1 = _this.centerImage, ref2 = _this.centerImage + Math.floor((_this.images.length - 1) / 2.0); ref1 <= ref2 ? l <= ref2 : l >= ref2; i = ref1 <= ref2 ? ++l : --l) {
        j = (i + _this.images.length) % _this.images.length;
        if (i === _this.centerImage + Math.floor((_this.images.length - 1) / 2.0)) {
          _this.images[j].css('transition', 'none');
        } else {
          _this.images[j].css('transition', '');
        }
        _this.images[j].offset({
          left: x
        });
        _this.images[j].css('z-index', 100 - (i - _this.centerImage));
        $(_this.images[j][0].firstChild).css('filter', i === _this.centerImage ? '' : 'brightness(80%)');
        x += _this.images[j].width() - 1;
      }
      x = containerLeft + (containerWidth - _this.images[_this.centerImage].width()) / 2;
      for (i = m = ref3 = _this.centerImage - 1, ref4 = _this.centerImage - Math.ceil((_this.images.length - 1) / 2.0); ref3 <= ref4 ? m <= ref4 : m >= ref4; i = ref3 <= ref4 ? ++m : --m) {
        j = (i + _this.images.length) % _this.images.length;
        x -= _this.images[j].width() - 1;
        _this.images[j].offset({
          left: x
        });
        _this.images[j].css('z-index', 100 + (i - _this.centerImage));
        $(_this.images[j][0].firstChild).css('filter', 'brightness(80%)');
      }
      return _this.timer = setTimeout(function() {
        return _this.start();
      }, 4000);
    };
  })(this);

  this.stop = (function(_this) {
    return function() {
      if (_this.timer) {
        clearTimeout(_this.timer);
        return _this.timer = null;
      }
    };
  })(this);

  this.on('mount', function() {
    return loadImages().then((function(_this) {
      return function() {
        var i, img, k, len, photo, ref;
        ref = _this.topPhotos;
        for (i = k = 0, len = ref.length; k < len; i = ++k) {
          photo = ref[i];
          img = $(".my-carousel img[data-id=" + i + "]");
          _this.images.push($(img[0].parentElement));
        }
        _this.start();
        $(window).on('resize', function() {
          return _this.start(_this.centerImage);
        });
        $(_this.root).on('mouseenter mousemove', function() {
          return _this.stop();
        });
        return $(_this.root).on('mouseleave', function() {
          return _this.start(_this.centerImage);
        });
      };
    })(this));
  });

  this.on('unmount', function() {
    return this.stop();
  });

}).call(this);
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/page-index-carousel.tag.slim
// module id = 35
// module chunks = 0